import React, { Component } from 'react'
import { get } from '../../utils/networking'
import { configs } from '../../helpers/constants'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";
import './style.css'
export default class CheckInPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isCheckInSuccess: false,
            isCheckingIn: false
        }
    }

    componentDidMount() {

    }

    handleCheckIn() {
        this.setState({
            isCheckingIn: true
        })
        let param = {
            storeId: this.props.currentStore.id,
            customerId: this.props.profile.user.id
        }
        get("appointment/checkin/" + param.storeId + "/" + param.customerId, "customer", result => {
            this.setState({
                isCheckInSuccess: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isCheckInSuccess: false,
                        isCheckingIn: false
                    })
                }, 3000);
            })
        })
    }

    render() {
        let {
            isShow,
            profile,
            currentStore,
        } = this.props;
        let {
            isCheckInSuccess,
            isCheckingIn
        } = this.state;

        return (
            <div>
                {
                    (isShow) ?
                        <div id="check_in_box">
                            <div className="check_in_popup">
                                <div className="header">
                                    <span>Check in now?</span>

                                </div>
                                {
                                    (!isCheckInSuccess) ? <div className="detail">
                                        <div className="content">
                                            <p>Hi {(profile.user) ? profile.user.firstName : ""}!</p>
                                            {
                                                profile.stores && profile.stores.map((item, i) =>
                                                    <div
                                                        className={(currentStore.id === item.id) ? "store-item active" : "store-item"}
                                                        onClick={() => this.props.changeCurrentStore(item)}
                                                        key={i}
                                                    >
                                                        <div className="store-image">
                                                            <img src={configs.posUploadDomain + ((item.logo.length > 0) ? (item.logo[0].imageURL) : "")} />
                                                        </div>
                                                        <div className="store-name">
                                                            <span>{item.name}</span>
                                                        </div>
                                                    </div>)
                                            }
                                        </div>
                                        <div className="submit">
                                            <div className="cancel">
                                                <span onClick={() => this.props.cancel()}> Cancel</span>
                                            </div>
                                            <div className="yes">
                                                <span onClick={() => this.handleCheckIn()}> {(isCheckingIn) ? "Wating..." : "Check in"}</span>
                                            </div>
                                        </div>
                                    </div> :
                                        <div className="detail success">
                                            <div className="content">
                                                <span>You have Success  signin</span>
                                                <div className="submit">
                                                    <span onClick={() => this.props.cancel()}>Ok</span>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div> : ""
                }
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/checkInPopup/index.js